module.exports = __webpack_public_path__ + "static/media/koala.2bbb92a0.png";